import { UserPlus } from 'lucide-react';
import { LeadCreatedEvent as LeadCreatedEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: LeadCreatedEventType;
}

export default function LeadCreatedEvent({ event }: Props) {
  const name = [event.payload.lead_first_name, event.payload.lead_last_name].filter(Boolean).join(' ');

  return (
    <EventShell
      color="green"
      icon={<UserPlus className="w-3.5 h-3.5" />}
      title="Contact Created"
      timestamp={event.created_at}
    >
      {name && <p className="font-medium text-foreground">{name}</p>}
      {event.payload.lead_email && <p>{event.payload.lead_email}</p>}
    </EventShell>
  );
}
